// Saved-view parameter (de)serialization (phase 24) — pure, so the
// round trip "current filter state → saved params → applied state" is
// unit-testable. A view's params are the page's filter/search/tab state
// with empty values dropped and keys sorted (stable equality).

export type ViewParams = Record<string, string>;

/** Drop null/undefined/empty values; everything stored is a real choice. */
export function normalizeParams(
  state: Record<string, string | null | undefined>,
): ViewParams {
  const out: ViewParams = {};
  for (const key of Object.keys(state).sort()) {
    const v = state[key];
    if (v !== null && v !== undefined && v !== '') out[key] = v;
  }
  return out;
}

/** Stable JSON (sorted keys) — what the saved_views.params column stores. */
export function serializeParams(state: Record<string, string | null | undefined>): string {
  return JSON.stringify(normalizeParams(state));
}

export function parseParams(json: string): ViewParams {
  try {
    const raw = JSON.parse(json) as unknown;
    if (typeof raw !== 'object' || raw === null || Array.isArray(raw)) return {};
    const out: ViewParams = {};
    for (const [k, v] of Object.entries(raw)) {
      if (typeof v === 'string' && v !== '') out[k] = v;
    }
    return out;
  } catch {
    return {};
  }
}

/** Does the live page state match this saved view? (active-chip test) */
export function paramsEqual(
  a: Record<string, string | null | undefined>,
  b: Record<string, string | null | undefined>,
): boolean {
  return serializeParams(a) === serializeParams(b);
}
